<template>
  <Dialog :visible="csDialog" modal :closable="false" :header="csDialogHeader" :style="{ width: '110rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

    <div class="flex ">
        <DataTable ref="dt" :value="csData" size="small" exportFilename="CS Report" showGridlines stripedRows tableStyle="width: 100vw" class="pl-3 pr-5" dataKey="oemPoItemId_1" scrollable scrollHeight="400px" >
            <Column header="Sl No." style="width:3%">
                <template #body="slotProps">
                    {{slotProps.index + 1}}
                </template>
            </Column>
            <Column field="itemName" header="Item"></Column>
            <Column field="quantity" header="Quantity"></Column>
            <Column field="packing" header="Packing"></Column>
            <Column field="rateInclGst" header="Sale Rate In-GST"></Column>
            <Column field="subTotalInclGst" header="Sale Amount In-GST"></Column>
            <Column field="rateExGst" header="Sale Rate Ex-GST"></Column>
            <Column field="subTotalExGst" header="Sale Amount Ex-GST"></Column>
            <Column field="gst" header="GST (%)"></Column>

            <Column field="costRateExGst_1" header="Cost Rate Ex-GST L1"></Column>
            <Column field="costAmountExGst_1" header="Cost Amount Ex-GST L1"></Column>
            <Column field="oem_1" header="OEM L1"></Column>
            <Column field="profitMargin_1" header="Margin L1"></Column>
            <Column field="profitMarginPercentage_1" header="Margin (%) L1"></Column>

            <Column field="costRateExGst_2" header="Cost Rate Ex-GST L2"></Column>
            <Column field="costAmountExGst_2" header="Cost Amount Ex-GST L2"></Column>
            <Column field="oem_2" header="OEM L2"></Column>
            <Column field="profitMargin_2" header="Margin L2"></Column>
            <Column field="profitMarginPercentage_2" header="Margin (%) L2"></Column>

            <Column field="costRateExGst_3" header="Cost Rate Ex-GST L3"></Column>
            <Column field="costAmountExGst_3" header="Cost Amount Ex-GST L3"></Column>
            <Column field="oem_3" header="OEM L3"></Column>
            <Column field="profitMargin_3" header="Margin L3"></Column>
            <Column field="profitMarginPercentage_3" header="Margin (%) L3"></Column>
        </DataTable>
    </div>

    <template #footer>
        <div class="flex justify-content-end flex-wrap">
          <Button label="Export CSV" raised size="small" class="mr-2" v-tooltip.top="'Export CSV file'" @click="exportCSV"/>
            <Button label="Close" severity="danger" size="small" @click="closeCsDialog"/>
        </div>
    </template>
  </Dialog>
</template>

<script>
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';

export default {
    name:'csDialogComponent',
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        visibility: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Dialog,
        DataTable,
        Column,
        Button,
    },
    mounted() {
        this.csData = this.data;
        this.csDialog = this.visibility;
    },
    data() {
        return {
            csDialog: false,
            csDialogHeader: 'CS Report',
            csData: [],
        };
    },
    methods:{
        closeCsDialog() {
            this.csDialog = false;
            this.$emit('close-dialog', this.csDialog);
        },
        exportCSV() {
            this.$refs.dt.exportCSV();
        },
    }
}
</script>

<style>

</style>